<template>
    <div class="post__head">
        <div class="box">
            <img alt="Logo" class="logo" src="@/assets/img/logo.png" />
            <p>{{ author }}<span class="post__head__separator">-</span><br class="hidden" /> {{ formattedDate }} <span
                    class="post__head__separator">-</span> {{ readTime }} <span class="post__head__readTime">{{ $t('blog.post.head.readTime') }}</span></p>
        </div>
    </div>
</template>
<style scoped>
.post__head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    color: var(--ComplementaryColor04);
    margin: 0 0 2rem 0;
}

.post__head__separator {
    margin: 0 0.8rem;
}

.box {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 2.8rem;

    p {
        margin: 0 0 0.5rem 0;
    }
}
.hidden {
    display: none;
}
.logo {
    width: auto;
    height: 35px;
}

@media only screen and (max-width: 768px) {
    .post__head {
        font-size: 14px !important;
        font-weight: 500;
        line-height: 1.2;
        margin: 0 0 1rem 0;
    }
    .hidden {
        display: inline;
    }
    .post__head__separator:first-child {
        display: none;
    }
    .post__head__separator {
        margin: 0 0.1rem;
    }
    .logo {
        width: auto;
        height: 45px;
    }
    .box {
        gap: 1rem;
        align-items: center;
    }
    .post__head__readTime {
        display: none;
    }

}
</style>
<script setup>
import { computed, inject, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';

import 'dayjs/locale/es';
import 'dayjs/locale/en';

const { locale } = useI18n();

dayjs.locale(locale.value);

const postHeadProps = inject('postHeadProps')

const author = computed(() => {
    return postHeadProps?.value?.author || '';
});

const readTime = computed(() => {
    return postHeadProps?.value?.readTime || '';
});

const formattedDate = computed(() => {
    dayjs.locale(locale.value);
    if (!postHeadProps?.value?.pubDate) return '';

    const rawDate = dayjs(postHeadProps?.value?.pubDate)

    const localeFormat = locale.value === 'es' ? 'D MMMM YYYY' : 'MM D YYYY';

    return rawDate.format(localeFormat).split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
});

watch([() => locale.value], () => {
    dayjs.locale(locale.value);
})
</script>